document.addEventListener('DOMContentLoaded', function() {
  function sortBundleOptions() {
    const bundleContainer = document.getElementById('simple-bundles-io-options');
    
    if (bundleContainer) {
      const selects = bundleContainer.querySelectorAll('select');
      
      selects.forEach(select => {
        const selectedValue = select.value;
        const options = Array.from(select.options);
        
        const placeholderOption = options.find(opt => opt.disabled && opt.value === '');
        const regularOptions = options.filter(opt => !(opt.disabled && opt.value === ''));
        
        // Transform option text format BEFORE sorting
        regularOptions.forEach(option => {
          // Transform text from "ProductName - VariantSize" to "VendorTitle inspired - ProductName"
          const optionText = option.text.trim();
          const parts = optionText.split(' - ');
          
          if (parts.length === 2) {
            const productName = parts[0].trim();
            
            // Look up vendor from the lookup table
            const vendorTitle = window.bundleVendorLookup && window.bundleVendorLookup[productName];
            
            if (vendorTitle) {
              // Remove "Inspired By" prefix if it exists and decode HTML entities
              let cleanVendorTitle = vendorTitle.replace(/^Inspired By\s*/i, '');
              
              // Decode HTML entities
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = cleanVendorTitle;
              cleanVendorTitle = tempDiv.textContent || tempDiv.innerText || cleanVendorTitle;
              
              option.text = `${cleanVendorTitle} inspired - ${productName}`;
            }
          }
        });
        
        // Sort options by the transformed text
        regularOptions.sort((a, b) => {
          const textA = a.text.trim().toLowerCase();
          const textB = b.text.trim().toLowerCase();
          return textA.localeCompare(textB);
        });
        
        select.innerHTML = '';
        
        if (placeholderOption) {
          select.appendChild(placeholderOption);
        }
        
        regularOptions.forEach(option => {
          select.appendChild(option);
        });
        
        select.value = selectedValue;
      });
      
      clearInterval(checkInterval);
    }
  }
  
  const checkInterval = setInterval(sortBundleOptions, 500);
  
  setTimeout(() => {
    clearInterval(checkInterval);
  }, 10000);
});